module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f1bf6cbb060ea625bdbcdc0163b1a292.png";